export default __webpack_public_path__ + "94d986b35c23957616e01b9650719b9e.png";